import React, { useContext } from 'react';
import "./newCourseForm.scss"
import {useHistory, withRouter} from "react-router-dom";
import { Formik, Form, Field } from "formik";
import { StoreContext } from '../../store/context'
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import InputAdornment from '@material-ui/core/InputAdornment';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select'
import FormControl from '@material-ui/core/FormControl';
import Paper from '@material-ui/core/Paper';

const NewCourseForm = () => {
    const history = useHistory();
    const { state, actions } = useContext(StoreContext); // get global state and dispatch function
    const { subjectName, programLvl, fee  } = state.formStates.courseRegistration; // get field data from global state
    const { setFormData } = actions.formActions; // export setFormData function
    const { registerNewCourse } = actions.registrationActions; // export setFormData function

    return (
        <div className="form-container">
            <h1 className="header">Course Registration Form</h1>
            <Formik
                initialValues={{
                    subjectName: `${subjectName ? subjectName : ''}`,
                }}
                onSubmit={(values, { setSubmitting, resetForm }) => {
                    setFormData({studentRegistration : values}); // pass data to global state
                    registerNewCourse(values, resetForm);
                    setSubmitting(false);
                }}
            >
                {({ isSubmitting }) => (
                    <Form>
                        <Paper className="paper" elevation={5}>
                            <h2 className="header">Course Info</h2>
                            <div className="input-field-container">
                                <Field name="subjectName">
                                    {({ field, form: { touched, errors } }) => (
                                        <>
                                            <TextField {...field} label="Subject Name" variant="filled" className="input-field"/>
                                        </>
                                    )}
                                </Field>
                            </div>
                        </Paper>

                        {/*add few fields*/}


                        {/* default submit button will fire  "onSubmit" function when clicked */}
                        <div>
                            <Button variant="contained" type="submit" color="primary" disabled={isSubmitting} className="submit-button">
                                Submit
                            </Button>
                        </div>
                    </Form>
                )}
            </Formik>
        </div>
    )
}

export default withRouter(NewCourseForm)